<template>
  <div id="setmall">
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <div>
        <div
          class="br-pagetitle d-flex justify-content-between align-items-center"
        >
          <div class="d-flex align-items-center">
            <i
              class="fa fa-flag-checkered"
              style="color: #17a2b8; font-size: 70px"
            ></i>
            <div class="mg-l-20">
              <h4>{{ $t("other.包装验货") }}</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="card mg-x-50 pd-20 mg-y-20 card-subuser">
        <div class="form-group row mg-b-0" style="align-items: stretch">
          <div class="col-md-4 col-sm-12 align-items-center mg-b-0">
            <div
              class="
                pos-relative
                mg-t-30
                pd-25 pd-xs-40
                rounded
                bd bd-white-2
                bg-black-3
              "
            >
              <ul class="login-tab d-flex pd-0 mg-0 wd-100p">
                <li class="wd-50p" :class="active == 1 ? 'active' : ''">
                  <a href="javascript:;" @click="changeInspection('1')">{{
                    $t("other.按物流单号 + SKU验货")
                  }}</a>
                </li>
                <li class="wd-50p" :class="active == 2 ? 'active' : ''">
                  <a href="javascript:;" @click="changeInspection('2')">{{
                    $t("other.按物流单号验货")
                  }}</a>
                </li>
              </ul>
              <div class="mg-b-15">
                <input
                  type="text"
                  :disabled="disabledState"
                  id="focusTrackState2"
                  class="form-control tx-16 tx-bold"
                  :placeholder="$t('other.物流单号')"
                  @keyup.enter="getSkuList()"
                  v-model.trim="trackNum"
                />
              </div>
              <div class="mg-b-30" v-show="active == 1">
                <input
                  type="text"
                  id="focusState2"
                  class="form-control tx-16 tx-bold"
                  :placeholder="$t('other.SKU编号')"
                  @keyup.enter="changeSkuNum()"
                  v-model.trim="skuNum"
                />
              </div>
              <div class="tx-center">
                <a
                  href="javascript:;"
                  class="btn btn-sm btn-primary"
                  @click="reset"
                  >{{ $t("other.重置") }}</a
                >
              </div>
            </div>
          </div>
          <div class="col-md-8 col-sm-12">
            <div
              class="pos-relative pd-0 rounded bd bd-white-2 bg-black-3"
              style="height: 100%"
            >
              <div style="height: 100%">
                <div
                  v-if="!successInsp && skuItems.length > 0"
                  class="card pd-y-15"
                  style="height: 100%"
                >
                  <div class="row mg-b-15 tx-16 tx-white">
                    <div class="col-4 tx-right">
                      {{ $t("other.物流单号") }}：
                    </div>
                    <div class="col-8 tx-bold">{{ showCard.trackNum }}</div>
                  </div>
                  <div class="row mg-b-15 tx-16 tx-white">
                    <div class="col-4 tx-right">
                      {{ $t("other.SKU品类数：") }}
                    </div>
                    <div class="col-8">
                      <span class="tx-bold">{{ skuItems.length }}</span
                      >{{ $t("other.种") }}
                    </div>
                  </div>
                </div>
                <div
                  v-if="successInsp && skuItems.length == 0"
                  class="card pd-y-15 border-success bg-success"
                  style="height: 100%"
                >
                  <div class="row mg-b-15">
                    <div class="col-12 tx-18 tx-center tx-white">
                      {{ $t("other.验货成功！") }}
                    </div>
                  </div>
                  <div class="row mg-b-15 tx-16 tx-white">
                    <div class="col-4 tx-right">
                      {{ $t("other.物流单号") }}：
                    </div>
                    <div class="col-8 tx-bold">{{ showCard.trackNum }}</div>
                  </div>
                </div>
                <div
                  v-if="failInsp"
                  class="card pd-y-15 border-danger bg-danger"
                  style="height: 100%"
                >
                  <div class="row mg-b-15">
                    <div class="col-12 tx-18 tx-center tx-white">
                      {{ $t("other.验货失败！") }}
                    </div>
                  </div>
                  <div class="row mg-b-15 tx-16 tx-white">
                    <div class="col-4 tx-right">
                      {{ $t("other.物流单号") }}：
                    </div>
                    <div class="col-8 tx-bold">{{ showCard.trackNum }}</div>
                  </div>
                  <div class="row tx-16 tx-white">
                    <div class="col-4"></div>
                    <div class="col-8">
                      <span class="tx-bold">{{ showCard.errorMsg }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="br-pagebody" id="offerSkuList">
        <div class="card bd-gray-400 mg-x-20 pd-0 mg-t-30">
          <table class="table mg-b-0 table-contact data-table">
            <thead>
              <tr>
                <th class="wd-lg-300">{{ $t("other.商品信息") }}</th>
                <th class="wd-lg-150">{{ $t("other.仓位") }}</th>
                <th class="wd-lg-150">{{ $t("other.库存") }}</th>
                <th class="wd-lg-150">{{ $t("other.采购数") }}</th>
                <th class="wd-lg-150">{{ $t("other.待验数") }}</th>
                <th class="wd-lg-150">{{ $t("other.状态") }}</th>
              </tr>
            </thead>
            <tbody>
              <template>
                <tr
                  class="tx-12"
                  v-for="(item, index) in skuItems"
                  :key="index"
                  :class="item.inpectNum > 0 ? '' : 'bg-gray-300'"
                >
                  <td class="valign-middle">
                    <div class="media d-block d-sm-flex align-items-center">
                      <a
                        class="p-img-wrap"
                        href="javascript:;"
                        :data-lightbox="index"
                        :data-title="'SKU: ' + item.sku"
                        :data-orderI="index"
                        v-lazy:background-image="item.imgUrl"
                      >
                      </a>
                      <div
                        class="
                          media-body
                          align-self-center
                          mg-t-10 mg-b-10
                          tx-12
                          pos-relative
                        "
                      >
                        <p class="mg-b-5 tx-ellipsis2">
                          {{ $t("other.商品") }}:
                          <span class="tx-gray-300">{{ item.name }}</span>
                        </p>
                        <p class="mg-b-5">
                          SKU:
                          <span class="tx-gray-300">{{ item.sku }}</span>
                          <a
                            v-show="item.sku"
                            class="to-clipboard"
                            href="javascript:;"
                            :data-clipboard-text="item.sku"
                          >
                            <i class="icon ion-clipboard"></i>
                          </a>
                        </p>
                        <p class="mg-b-0">
                          {{ $t("other.重量（g）") }}：<span
                            class="tx-gray-300"
                            >{{ Number(item.weight).toFixed(2) }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </td>
                  <td class="valign-middle">
                    <span class="tx-gray-300">{{ item.positionName }}</span>
                  </td>
                  <td class="valign-middle">
                    <span class="tx-gray-300">{{ item.quantity }}</span>
                  </td>
                  <td class="valign-middle">
                    <span class="tx-success">{{ item.deliveryCnt }}</span>
                  </td>
                  <td class="valign-middle">
                    <span class="tx-warning">{{ item.inpectNum }}</span>
                  </td>
                  <td class="valign-middle">
                    <span
                      :class="item.inpectNum > 0 ? 'tx-warning' : 'tx-success'"
                      >{{
                        item.inpectNum > 0
                          ? $t("other.待验货")
                          : $t("other.已验货")
                      }}</span
                    >
                  </td>
                </tr>
              </template>
              <tr v-if="(!skuItems || skuItems.length < 1) && !loading">
                <td colspan="6">
                  <div class="col-12 none-product">
                    <i class="fa fa-ban"></i
                    >{{ $t("other.没有符合条件的数据") }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <api-loading :show="loading"></api-loading>
  </div>
</template>

<script>
export default {
  props: ["user_info", "white_style"],
  data() {
    return {
      leftSideStatus: true, //左边栏$t('other.状态')
      loading: false,
      active: 1,
      trackNum: "",
      trackNumCopy: "",
      skuNum: "",
      successInsp: false,
      failInsp: false,
      focusState: false,
      focusTrackState: true,
      disabledState: false,
      skuItems: [],
      failTxt: "",
      showCard: {
        trackNum: "",
        errorMsg: "",
      },
    };
  },
  created() {
    this.focusTrackState = true;
  },
  watch: {
    active: function () {
      this.reset();
    },
    trackNum: function () {
      if (this.trackNum != "") {
        if (localStorage.getItem("inspectData")) {
          let inspectData = JSON.parse(localStorage.getItem("inspectData"));
          if (this.trackNum == inspectData.trackNum) {
            if (inspectData.data.length > 0) {
              inspectData.data.forEach((e, i) => {
                this.skuItems.forEach((s, q) => {
                  if (e.sku == s.sku) {
                    this.$set(s, "inpectNum", e.inpectNum);
                  }
                });
              });
            }
          }
        }
      }
    },
  },
  directives: {
    focus: {
      update: function (el, { value }) {
        if (value) {
          el.focus();
        }
      },
    },
  },
  mounted() {
    document.getElementById("focusTrackState2").focus();
  },
  methods: {
    playSound(type) {
      let src = type == "success" ? "audio/save.mp3" : "audio/error.mp3";
      var borswer = window.navigator.userAgent.toLowerCase();
      if (borswer.indexOf("ie") >= 0) {
        //IE$t('other.内核浏览器')
        var strEmbed =
          '<embed name="embedPlay" src="' +
          src +
          '" autostart="true" hidden="true" loop="false"></embed>';
        if ($("body").find("embed").length <= 0) $("body").append(strEmbed);
        var embed = document.embedPlay;

        //$t('other.浏览器不支持') audion$t('other.，则使用') embed $t('other.播放')
        embed.volume = 100;
        //embed.play();$t('other.这个不需要')
      } else {
        //$t('other.非')IE$t('other.内核浏览器')
        var strAudio = '<audio id="audioPlay" src="' + src + '" hidden="true">';
        if ($("body").find("audio").length <= 0) {
          $("body").append(strAudio);
          var audio = document.getElementById("audioPlay");
        } else {
          $("body").find("audio").remove();
          $("body").append(strAudio);
          var audio = document.getElementById("audioPlay");
        }
        audio.play();
      }
    },
    reset() {
      this.failTxt = "";
      this.failInsp = false;
      this.successInsp = false;
      this.focusTrackState = true;
      this.focusState = false;
      this.disabledState = false;
      this.trackNum = "";
      this.skuNum = "";
      this.skuItems = [];
      setTimeout(() => {
        document.getElementById("focusTrackState2").focus();
      }, 100);
    },
    getSkuList() {
      if (!this.isSysRights("Order.getPackageInfo")) return;
      if (!this.trackNum) {
        ShowTip(this.$t("other.请扫描物流单号"), "danger");
        return;
      }
      this.loading = true;
      let getData = (data) => {
        this.showCard = {
          trackNum: this.trackNum,
          errorMsg: "",
        };
        this.failInsp = false;
        this.skuItems = data.Results[0].productInfo
          ? data.Results[0].productInfo
          : [];
        if (this.skuItems.length > 0) {
          this.successInsp = false;
          document.getElementById("focusState2").focus();
          this.focusTrackState = false;
          this.focusState = true;
          this.disabledState = true;
          this.skuItems.forEach((e) => {
            this.$set(e, "inpectNum", e.deliveryCnt);
          });
          if (this.active == 2) {
            this.skuItems.forEach((e) => {
              this.$set(e, "inpectNum", 0);
            });
            this.checkPackageSku();
          }
          if (localStorage.getItem("inspectData") && this.active == 1) {
            let inspectData = JSON.parse(localStorage.getItem("inspectData"));
            if (this.trackNum == inspectData.trackNum) {
              if (inspectData.data.length > 0) {
                inspectData.data.forEach((e, i) => {
                  this.skuItems.forEach((s, q) => {
                    if (e.sku == s.sku) {
                      this.$set(s, "inpectNum", e.inpectNum);
                    }
                  });
                });
              }
            }
          }
        }
      };
      $.api_call(
        "api.Order.getPackageInfo",
        {
          expressCode: this.trackNum,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            getData(r.Data);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              this.playSound("fail");
              this.failInsp = true;
              this.successInsp = false;
              this.showCard = {
                trackNum: this.trackNum,
                errorMsg: r.Message,
              };
              this.focusTrackState = true;
              this.focusState = false;
              this.disabledState = false;
              this.trackNum = "";
            }
          }
        }
      );
    },
    changeSkuNum() {
      if (!this.skuNum) {
        ShowTip(this.$t("other.请扫描SKU"), "danger");
        return;
      }
      let errorNum = this.skuItems.length > 0 ? this.skuItems.length : 1;
      let successNum = 0;
      this.skuItems.forEach((e) => {
        if (this.skuNum == e.sku) {
          if (e.inpectNum > 0) e.inpectNum--;
        } else {
          errorNum--;
        }
        if (e.inpectNum == 0) {
          successNum++;
        }
      });
      if (errorNum == 0) {
        ShowTip(this.$t("other.包裹里没有匹配的SKU"), "danger");
        return;
      }
      if (successNum == this.skuItems.length) {
        this.checkPackageSku();
      }
      let inspectData = {
        trackNum: this.trackNum,
        data: this.skuItems,
      };
      localStorage.setItem("inspectData", JSON.stringify(inspectData));
      this.skuNum = "";
    },
    checkPackageSku() {
      if (!this.isSysRights("Order.checkPackageSku")) return;
      this.trackNumCopy = this.trackNum;

      let verifyInfo = [];
      this.skuItems.forEach((e) => {
        verifyInfo.push({ sku: e.orSku, verifyQuantity: e.deliveryCnt });
      });
      let param = {
        expressCode: this.trackNum,
        verifyInfo: verifyInfo,
      };
      this.loading = true;
      $.api_call("api.Order.checkPackageSku", param, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          this.playSound("success");
          this.showCard = {
            trackNum: this.trackNum,
            errorMsg: "",
          };
          this.focusTrackState = true;
          this.successInsp = true;
          this.focusState = false;
          this.disabledState = false;
          this.failInsp = false;
          this.trackNum = this.skuNum = "";
          this.skuItems = [];
          setTimeout(() => {
            document.getElementById("focusTrackState2").focus();
          }, 100);
          localStorage.removeItem("inspectData");
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            this.playSound("fail");
            this.showCard = {
              trackNum: this.trackNum,
              errorMsg: r.Message,
            };
            this.failInsp = true;
            this.successInsp = false;
            this.failTxt = r.Message;
          }
        }
      });
    },
    changeInspection(type) {
      this.active = type;
      this.reset();
    },
    changeSkuNumByTrack() {
      this.getSkuList();
    },
  },
};
</script>

<style scoped="scoped">
.show-white-style .tx-white {
  color: #343a40 !important;
}
.img-wrap {
  border: 1px rgba(0, 0, 0, 0.3) solid;
  width: 60px;
  height: 60px;
  background-repeat: no-repeat;
  background-size: 100%;
}
.data-table tbody tr.bg-gray-300:hover,
.data-table .hover:hover {
  background-color: #dee2e6 !important;
}
input[type="text"]:focus {
  box-shadow: 0 0 4px #55a6f8;
  background-color: #c4e0fd;
}
</style>